import {
  getRoleUrisFromRoleNames,
  getSupportNLabels,
} from 'services/roles-services'
import { UserEntity } from 'utils/__interfaces/Administrations/Users/UserEntity'
import {
  ADMIN_ROLES,
  ROLE_SYMBOLE,
  SUPPORT_ROLES,
} from 'utils/__consts/Common/ROLES'
import AllRolesEntity from 'utils/__interfaces/Roles/AllRolesEntity'
import Option from 'utils/__interfaces/Common/Dropdown'
import {
  SERVICE_AUTRE_VALUE,
  SERVICES_LIST,
} from 'utils/__consts/Common/Service'

export default function userCanBeActivated(user: UserEntity): boolean {
  let haveContrat = false
  let havePerimeter = false
  if (user.contratId) haveContrat = true
  if (user.organizations.length > 0) havePerimeter = true
  return haveContrat && havePerimeter
}

export const getStatusValue = (
  status: string,
  AvailableOptions: { value: string; label: string }[]
): string => {
  let statusLabel = ''
  AvailableOptions.forEach((option) => {
    if (option.value === status) statusLabel = option.label
  })
  return statusLabel
}

export const getAdminUserSymbol = (
  userRoles: string[] | undefined,
  allRoles: AllRolesEntity[],
  fullCharacters?: boolean
): string => {
  if (userRoles?.length === 1) {
    const roleName = allRoles.filter((role) => role.id === userRoles[0])[0].name
    if (SUPPORT_ROLES.includes(roleName)) {
      return getSupportNLabels(roleName, fullCharacters)
    }
  }

  const displayRoleAs = fullCharacters
    ? ROLE_SYMBOLE.fullCharacters
    : ROLE_SYMBOLE.abbreviation
  const adminRoleUris = getRoleUrisFromRoleNames(ADMIN_ROLES, allRoles)
  return userRoles?.some((role: string) => adminRoleUris.includes(role))
    ? displayRoleAs
    : ''
}

export function isSuezMail(email: string): boolean {
  return ['suez.com', 'suez.fr', 'suezenvironnement.com'].includes(
    email.toLowerCase().split('@')[1]
  )
}

export const isServiceAutre = (service?: string | null): boolean =>
  service === SERVICE_AUTRE_VALUE

export const getServiceDisplayValue = (service?: string | null): string =>
  isServiceAutre(service) ? '' : service ?? ''

export const getServiceSelectValue = (
  service?: string | null
): Option | null => {
  const displayValue = getServiceDisplayValue(service)

  return displayValue ? { label: displayValue, value: displayValue } : null
}

export const getServiceList = (): Option[] => {
  return SERVICES_LIST.map((service) => ({
    label: service,
    value: service,
  }))
}
